import Vue from 'vue'
import Vuex from 'vuex'

import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import utils from '../utils/index.js'
import { i18n } from '../lang/i18n.js'
Vue.use(Vuex)

// 获取vuex所有模块
const modulesFiles = require.context('./modules', true, /\.js$/)
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export const store = new Vuex.Store({
  // 设置属性
  state: {
    videoVisible: false,
    videoObj: {
      url: '',
      image: ''
    },
    // 登陆状态 0 未登录 1 登录
    isLogin: Number(sessionStorage.isLogin) || 0,
    // 登录窗口显示
    loginFade: false,
    // 伸缩导航栏
    showSideBar: Number(localStorage.showSideBar || 1),
    // isLogin: sessionStorage.isLogin ? sessionStorage.isLogin : 0,
    // 用户信息
    userInfo: sessionStorage.userInfo,
    brandActiveTabName: 'first',
    countrys: [
      {
        cnName: '中国',
        enName: 'China',
        code: 'PRC'
      },
      {
        cnName: '韩国',
        enName: 'Korea',
        code: 'KOR'
      },
      {
        cnName: '菲律宾',
        enName: 'Philippines',
        code: 'PHL'
      },
      {
        cnName: '日本',
        enName: 'Japan',
        code: 'JPN'
      },
      {
        cnName: '马来西亚',
        enName: 'Malaysia',
        code: 'MYS'
      },
      {
        cnName: '印度',
        enName: 'India',
        code: 'IND'
      },
      {
        cnName: '印度尼西亚',
        enName: 'Indonesia',
        code: 'IDN'
      },
      {
        cnName: '泰国',
        enName: 'Thailand',
        code: 'THA'
      },
      {
        cnName: '新加坡',
        enName: 'Singapore',
        code: 'SGP'
      },
      {
        cnName: '新西兰',
        enName: 'New Zealand',
        code: 'NZL'
      },
      {
        cnName: '越南',
        enName: 'Vietnam',
        code: 'VNM'
      },
      {
        cnName: '澳大利亚',
        enName: 'Australia',
        code: 'AUS'
      },
      {
        cnName: '巴基斯坦',
        enName: 'Pakistan',
        code: 'PAK'
      }
    ],
    compareNum: 0,
    compareBtnShow: false,
    showHeadSearch: true,
    // 菜单
    menus: sessionStorage.menus ? JSON.parse(sessionStorage.menus) : [],
    activeMenuPath: '/br-an',
    selectYears: [], // mutations -> getYears(num?)
    defaultYear: '2018',

    passwordDialogVisible: false,

    lang: i18n.locale,
    showAdvanceSearchAlert: false,
    // 用户登陆，并获取菜单
    loginInterfaceParams: {
      'functionName': 'combiz.service.SbaseUserService',
      'methodName': 'login',
      'loginId': '',
      'lang': null,
      'data': {
        'password': ''
      }
    },
    // 修改密码
    updatePasswordParams: {
      'functionName': 'combiz.service.SbaseUserService',
      'methodName': 'updatePassword',
      'loginId': '',
      'lang': 'en',
      'data': {
        'password': '',
        'newPassword': ''
      }
    },
    // 用户注册
    registerParams: {
      'functionName': 'combiz.service.SbaseUserService',
      'methodName': 'register',
      'data': {
        'username': '',
        'password': ''
      }
    },
    // 意见反馈
    insertUserFeedbackParams: {
      'functionName': 'combiz.service.SbaseUserService',
      'methodName': 'insertUserFeedback',
      'loginId': '',
      'lang': 'en',
      'data': {
        'module': null,
        'page': null,
        'score': null,
        'comment': null
      }
    },

    /**
     * boss ----------------------------------------------------------------------------
     */
    // 页面传参
    // boss 首页选中数据
    saveBossPageData1: localStorage.bossInfo ? JSON.parse(localStorage.bossInfo) : {},

    saveBossPageData3: localStorage.newDesignData ? JSON.parse(localStorage.newDesignData) : {},
    saveBossPageData4: localStorage.orderInfo ? JSON.parse(localStorage.orderInfo) : {},

    // Aask for new design as a Benchmark
    saveBenchmark: [],
    // 直接购买Purchase
    savePurchaseData: localStorage.purchaseData ? JSON.parse(localStorage.purchaseData) : {},
    // boss search
    bossSearchName: [],

    selectBossPopUpParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectBossPopUp',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'lang': 'en',
      'data': {

      }
    },
    bevolBrands: [],

    // selectProductClaimTop10
    selectProductClaimTop10Params: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectProductClaimTop10',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'orderBy': 'click',
        'ctgrIds': '',
        'prdctFormId': '',
        'prdctAspctId': '',
        'sunLevelId': '',
        'poplatnGroupId': '',
        'aplctnAreaId': '',
        'subAplctnAreaId': '',
        'maxRetailPrice': '',
        'minRetailPrice': '',
        'priceUnit': '',
        'claimIds': ''
      }
    },
    prdctClaimTop10s: [],

    // selectLastestFiveProducts
    selectLastestFiveProductParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectLastestFiveProducts',
      'loginId': '',
      'data': {
      }
    },
    prdctBeans: [],

    // selectFormuNewDesign
    selectFormuNewDesignParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectFormuNewDesign',
      'loginId': '',
      'data': {
        'brndId': ''
      }
    },

    // selectPurchase
    selectPurchaseParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectPurchase',
      'loginId': '',
      'data': {
      }
    },
    basfPurchaseFormus: [],
    basfPurchaseClaimSubsts: [],
    basfPurchaseDocuments: [],
    basfPurchaseCapacitys: [],
    basfPurchaseQuantitys: [],

    // insertOrder
    insertOrderParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'insertOrder',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'brndId': '',
        'brndName': '',
        'preSelect': '',
        'preViewFormu': '',
        'preViewPrd': '',
        'brndClaims': '',
        'prdctLink': '',
        'prdCategorys': '',
        'prdForm': '',
        'prdAspect': '',
        'applicationArea': '',
        'suncreenLevel': '',
        'popuGroups': '',
        'inIngredients': '',
        'exIngredients': '',
        'formulation': '',
        'claimSubstant': '',
        'documents': '',
        'capacity': '',
        'quantity': '',
        'contactName': '',
        'email': '',
        'companyName': '',
        'address': '',
        'deliveryOptions': ''
      }
    },
    insertOrderDatas: [],

    // 查询order详情
    selectOrderDetailParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectOrderDetail',
      'loginId': '',
      'data': {
        'id': null
      }
    },
    basfOrder: [],
    // 查询order列表
    selectOrderListParams: {
      'functionName': 'combiz.service.BossService',
      'methodName': 'selectOrderList',
      'loginId': null
    },
    orderList: [],

    // Documents
    searchDocumentsParams: {
      'functionName': 'combiz.service.SearchService',
      'methodName': 'searchDocuments',
      'pageNo': 1,
      'pageSize': 10,
      'lang': 'en',
      'loginId': '',
      'data': {
        'searchName': ''
      }
    },
    concepts: [],
    tradeDoucuments: [],
    conceptCount: 0,

    // searchAll
    searchAllParams: {
      'functionName': 'combiz.service.SearchService',
      'methodName': 'searchAll',
      'pageNo': 1,
      'pageSize': 10,
      'lang': 'en',
      'loginId': '',
      'data': {
        'searchName': ''
      }
    },
    allList: [],
    count: 0,

    /**
     * product ----------------------------------------------------------------------------
     */
    dshbrdPrddstrbtnChangeParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectDshbrdPrddstrbtnChange',
      'loginId': '',
      'data': {
        'dsYear': null,
        'dsCtgyId': null,
        'dsSubCtgyId': null,
        'dsGroupId': null,
        'dsBrndId': null
      }
    },
    dshbrdPrddstrbtnChangeDatas: [],

    productListParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductList',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'orderBy': null,
        // 暂时先注掉，查询接口没数据
        'brndId': null,
        'ctgrIds': '',
        'prdctFormId': null,
        'prdctAspctId': null,
        'sunLevelId': null,
        'poplatnGroupId': null,
        'aplctnAreaId': null,
        'subAplctnAreaId': null,
        'maxRetailPrice': null,
        'minRetailPrice': null,
        'priceUnit': null,
        'claimIds': '',
        'searchName': ''
      }
    },
    rptPrdctLists: [],
    productListSumCount: 0,

    prdctExcelDownloadParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'excelDownload',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },

    prdctListSmlrFomltnParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductListSmlrFomltn',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    prdctListSmlrFomltns: [],
    // product detail
    productDetailParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductDetail',
      'loginId': '',
      'data': {
        'prdctId': ''
      }
    },
    productDetailDatas: {},
    prdctBrnds: {},
    prdctDscrptns: {},
    prdctIngrdnts: [],
    // prdctSmlrFomltns: [],
    prdctFdbks: [],
    commntPrdctLocations: [],
    prdctComnts: [],
    commntPrdctSkintypes: [],
    commntPrdctAges: [],
    prdctClicks: [],
    clickPrdctLocations: [],
    clickPrdctSkintypes: [],
    prdctInterests: [],
    prdctAges: [],

    productSmlrFomltnParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductSmlrFomltn',
      'loginId': '',
      'data': {
        'prdctId': ''
      }
    },
    prdctSmlrFomltns: [],

    productIntstFomltnParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductIntstFomltn',
      'loginId': '',
      'data': {
        'prdctId': ''
      }
    },
    prdctIntstFomltns: [],

    // product index
    productIndexParams: {
      'functionName': 'combiz.service.PrdctService',
      'methodName': 'selectProductIndex',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'orderBy': 'click'
      }
    },
    // 假数据，需替换
    dshbrdClmsfrms: [],

    // product compare
    productComparisonParams: {
      'functionName': 'combiz.service.MyComparisonService',
      'methodName': 'selectProductComparison',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'contrastType': 1,
        'functionEnDisplay': null
      }
    },
    prdctList: [],

    changeIngrdntsParams: {
      'functionName': 'combiz.service.MyComparisonService',
      'methodName': 'changeIngrdnts',
      'loginId': '',
      'data': {
        'functionEnDisplay': null
      }
    },
    prdctComIngrdntBeans: [],

    selectProducTopIndexParams: {
      'functionName': 'combiz.service.PrdctTopService',
      'methodName': 'selectProducTopIndex',
      'loginId': '',
      'pageNo': 1,
      'pageSize': 10,
      'data': {
        // "orderBy": "click"
      }
    },
    selectProducTopIndexDatas: {},

    selectTop10ClaimAndProductFormParams: {
      'functionName': 'combiz.service.PrdctTopService',
      'methodName': 'selectTop10ClaimAndProductForm',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'dsYear': null,
        'dsCtgyId': null,
        'dsBrndId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    productForms: [],
    claimAndProductFormList: [],
    // selectTop10ClaimAndProductFormDatas: {},
    // top10ClaimAndProductForm: [],

    selectTop10ClaimAndSubCategoryParams: {
      'functionName': 'combiz.service.PrdctTopService',
      'methodName': 'selectTop10ClaimAndSubCategory',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'dsYear': null,
        'dsCtgyId': null,
        'dsBrndId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    subCategories: [],
    claimAndSubCategoryList: [],
    // selectTop10ClaimAndSubCategoryDatas: {},
    // top10ClaimAndSubCategory: [],

    selectTop10PrdDistClaimAndFormParams: {
      'functionName': 'combiz.service.PrdctTopService',
      'methodName': 'selectTop10PrdDistClaimAndForm',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'dsYear': null,
        'dsCtgyId': null,
        'dsBrndId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    selectTop10PrdDistClaimAndFormDatas: {},

    selectTop10PrdDistClaimAndSubCategoryParams: {
      'functionName': 'combiz.service.PrdctTopService',
      'methodName': 'selectTop10PrdDistClaimAndSubCategory',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'dsYear': null,
        'dsCtgyId': null,
        'dsBrndId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    selectTop10PrdDistClaimAndSubCategoryDatas: {},

    /**
     * formulation ----------------------------------------------------------------------------
     */
    // index
    formulationIndexParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnIndex',
      'loginId': ''
    },
    bevolSpecificPopuGroups: [],
    bevolSuncreenLevels: [],
    bevolSpfs: [],
    bevolApplicationAreas: [],
    bevolProductAllCategories: [],
    bevolProductAspects: [],
    bevolProductForms: [],

    formulationIndexDatas: [],
    // 使用部位
    formulationAppAreas: [],
    // 父级产品分类
    formulationProductCategories: [],
    // list
    formulationListParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnSearch',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'ctgrIds': '',
        'prdctFormEn': '',
        'prdctAspctEn': '',
        'sunLevelEn': '',
        'poplatnGroupEn': '',
        'aplctnAreaEn': '',
        'aplctnAreaSubEn': '',
        'inTradeName': '',
        'inInci': '',
        'exTradeName': '',
        'exInci': '',
        'tags': '',
        'searchName': ''
      }
    },
    formulationListDatas: [],
    formulationListSumCount: 0,
    // detail
    formulationDetailParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnDetail',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'fomltnId': ''
      }
    },
    applicationAreas: [],
    fomltnPerformance: {},
    fomltnSpcfctn: {},
    fomltnDetailBean: {},
    fomltnIngrdnts: [],
    fomltnProcess: {},
    basfFormuCommentList: [],
    fomltnIngrdntsPhase: {},

    formulationAddCommentParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'addComment',
      'loginId': '',
      'data': {
        'starNum': 2,
        'commentContent': '',
        'formulationId': ''
      }
    },
    fomltnSimilarParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnSimilar',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'fomltnId': null
      }
    },
    fomltnSimilars: [],
    fomltnIntstParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnIntst',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'fomltnId': null
      }
    },
    fomltnIntst: [],

    fomltnBenchmarkParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'selectFomltnBenchmarkProduct',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'ctgrIds': '',
        'claimsId': ''
      }
    },
    benchmarkProducts: [],

    excelDownloadParams: {
      'functionName': 'combiz.service.FomltnService',
      'methodName': 'excelDownload',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        ctgyH2En: null,
        prdctFormEn: null,
        prdctAspctEn: null,
        sunLevelEn: null,
        poplatnGroupEn: null,
        aplctnAreaEn: null,
        aplctnAreaSubEn: null,
        inTradeName: null,
        inInci: null,
        exTradeName: null,
        exInci: null,
        tags: null,
        searchName: null
      }
    },

    // excelDownloadParams: {
    //   "functionName": "combiz.service.TestService",
    //   "methodName": "selectTestExcelDownload",
    //   "loginId": "admin",
    //   "pageNo": 1,
    //   "pageSize": 10,
    //   "lang": "en",
    //   "data": {
    //     "fileName": ""
    //   }
    // },

    /**
     * ingredient ----------------------------------------------------------------------------
     */
    // Ingredients index params
    ingredientIndexParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntIndex',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'functionEnDisplay': null,
        'functionClaimId': null,
        'productCategoryId': null,
        'countryCode': null,
        'searchName': ''
      }
    },
    // Ingredients index datas
    basfFunctionBevols: [],
    ingrdntLstBeans: [],
    ingrdntListSumCount: 0,

    ingrdntExcelDownloadParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntListExcel',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    // Ingredients detail params
    ingredientDetailParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntDetail',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'ingrdntId': null,
        'ingrdntEn': null,
        'year': utils.defaultYear,
        'defyear': utils.defaultYear,
        'month': utils.defaultMonth
      }
    },
    // Ingredients detail datas
    ingrdntDtlBean: {},
    ingrdntDtlAplcatnByCtgies: [],
    ingrdntDtlAplcatnByYears: [],
    ingApaProducts: [],
    ingApaProductsTops: [],
    basfFunctionBevolSubs: [],

    selectIngrdntFunctionChange: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntFunctionChange',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': 'main',
      'data': {
        'functionEnDisplay': null
      }
    },
    ingrdntDtlRelateds: [],
    // ingrdntDtlFomulas: [],
    // trade name index
    ingrdntTrdIndexParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntTrdIndex',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'functionEnDisplay': '',
        'segmentName': '',
        'dlvryformEn': '',
        'ecoStatusCode': '',
        'searchName': ''
      }
    },
    basfFunctions: [],
    basfTrdmkSegment: [],
    basfFormOfDelivery: [],
    ecoStatus: [],
    ingrdntTrdLstBeans: [],
    ingrdntTrdListSumCount: 0,

    trdExcelDownloadParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntTrdListExcel',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    // trade name detail params
    ingrdntTrdDetailParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntTrdDetail',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': 'main',
      'data': {
        'prdNum': null,
        'tradeName': null
      }
    },
    ingrdntTrdDtlPrdinfoBasics: null,
    ingrdntTrdDtlPrdinfoStatements: null,
    ingrdntTrdDtlPrdinfoCertificates: null,
    ingrdntTrdDtlPrdinfoMSDS: null,
    ingrdntTrdDtlPrdinfoMarket: null,
    ingrdntTrdDtlRelatedfomltns: [],
    ingrdntTrdDtlLiteratures: [],
    ingrdntTrdDtlBean: {},

    ingApaProductsTopParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'getIngApaProductsTop',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'ingrdntId': null,
        'topyear': null,
        'month': null,
        'sortBy': null,
        'categoryId': null
      }
    },

    ingApaByCategoryParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'getIngApaByCategory',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'ingrdntId': null,
        'year': null
      }
    },
    ingApaByCategories: [],

    ingrdntTrdDetailRelatedfomltnParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntTrdDetailRelatedfomltn',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'prdNum': null,
        'tradeName': null
      }
    },

    ingrdntSmlrTradeNameParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntSmlrTradeName',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'prdNum': null
      }
    },
    smlrTradeNameBean: [],

    ingrdntCombinateSelectParams: {
      'functionName': 'combiz.service.IngrdntService',
      'methodName': 'selectIngrdntCombinateSelect',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'comIngrdnt': null
      }
    },
    ingrdntDtlFomulas: [],

    /**
     * concept collection ----------------------------------------------------------------------------
     */
    conceptIndexParams: {
      'functionName': 'combiz.service.ConceptService',
      'methodName': 'selectConceptList',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'updateYear': '',
        'segmentCode': '',
        'areaCode': '',
        'searchName': ''
      }
    },
    conceptsListSumCount: 0,
    conceptAreaCodes: [],

    conceptIndexParams2: {
      'functionName': 'combiz.service.ConceptService',
      'methodName': 'selectConceptIndex',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    hotConcepts: [],
    newConcepts: [],
    fomltnBeans: [],
    trdLstBeans: [],

    newConceptListParams: {
      'functionName': 'combiz.service.ConceptService',
      'methodName': 'selectNewConceptList',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    newConceptListSumCount: 0,
    conceptSegments: [],
    areaCodes: [],
    conceptListBeans: [],

    newConceptDetailParams: {
      'functionName': 'combiz.service.ConceptService',
      'methodName': 'selectNewConceptsDetail',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'id': null
      }
    },
    newConceptDetailDatas: {},

    /**
     * Comparison ----------------------------------------------------------------------------
     */
    selectFomltnComparisonParams: {
      'functionName': 'combiz.service.MyComparisonService',
      'methodName': 'selectFomltnComparison',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'contrastType': 3
      }
    },
    fomltnList: [],
    productList: [],

    selectIngrdntComparisonParams: {
      'functionName': 'combiz.service.MyComparisonService',
      'methodName': 'selectIngrdntComparison',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'contrastType': 2
      }
    },
    ingrdntList: [],
    allIngrdntFnctnlBeans: [],
    // basfIngrdntCompareFunctional: [],
    // ingrdntCompareFuncts: [],

    selectBrandComparisonParams: {
      'functionName': 'combiz.service.MyComparisonService',
      'methodName': 'selectBrandComparison',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': 'zhaodh',
      'data': {
        'contrastType': 4,
        'year': utils.defaultYear,
        'countryCode': 'PRC',
        'segmentEn': '',
        'subSegmentEn': ''

      }
    },
    brandList: [],
    /**
     * compare add and delete ----------------------------------------------------------------------------
     */
    addCompareParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'addtoCompare',
      'loginId': '',
      'data': {
        'contrastType': 0,
        'id': null,
        'productId': null
      }
    },
    deleteCompareParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'deleteCompare',
      'loginId': '',
      'data': {
        'contrastType': 0,
        'id': ''
      }
    },
    compareNumParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectCompareNum',
      'loginId': '',
      'data': {
        'contrastType': 0
      }
    },
    selectBasfAllFormulationClaimParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBasfAllFormulationClaim',
      'loginId': '',
      'data': {
        'claimType': null,
        'claimName': ''
      }
    },
    selectBasfAllFormulationClaimDatas: {},

    selectBevolBrandParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolBrand',
      'loginId': '',
      'data': {
        'groupId': null,
        'brandPositioning': null,
        'pricePositioning': null
      }
    },

    selectBasfFomlthTagsParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBasfFomlthTags',
      'loginId': '',
      'data': {
        'tagName': null
      }
    },
    basfFomlthTags: [],

    selectBasfTradeByNameParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBasfTradeByName',
      'loginId': '',
      'data': {
        'tradeName': null
      }
    },
    basfTrades: [],

    selectBasfInciByNameParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBasfInciByName',
      'loginId': '',
      'data': {
        'inciName': null
      }
    },
    basfIncis: [],

    /**
     * common interface params ----------------------------------------------------------------------------
     */
    bevolSubAreasParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolApplicationAreaSubCategories',
      'loginId': '',
      'data': {
        'id': ''
      }
    },
    bevolApplicationAreaSubCategories: [],

    bevolProductSubCategoriesParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolProductSubCategories',
      'loginId': '',
      'data': {
        'id': ''
      }
    },
    bevolProductSubCategories: [],

    bevolBrandByGroupParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolBrandByGroup',
      'loginId': '',
      'data': {
        'groupId': 0
      }
    },
    bevolGroupBrands: [],

    bevolBrandByBrandNameParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolBrandByBrandName',
      'loginId': '',
      'data': {
        'brandName': ''
      }
    },
    remoteBevolGroupBrands: [],

    basfMarketSubSegmentParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBasfMarketSubSegment',
      'loginId': '',
      'data': {
        'code': ''
      }
    },
    basfMarketSubSegment: [],

    bevolFunctionClaimByFunctionEnDisplayParams: {
      'functionName': 'combiz.service.CommonService',
      'methodName': 'selectBevolFunctionClaimByFunctionEnDisplay',
      'loginId': '',
      'data': {
        'functionEnDisplay': null
      }
    },
    bevolFunctionClaims: [],

    batchDownloadFiles: {
      'data': {
        'files': null
      }
    },

    // selectBasfFormulationClaimParams: {
    //   "functionName": "combiz.service.CommonService",
    //   "methodName": "selectBasfFormulationClaim",
    //   "loginId": "",
    //   "data": {
    //   }
    // },
    // basfFormulationClaims: [],

    /**
     * consumer insights ----------------------------------------------------------------------------
     */
    // 1.consumer insights => market overview
    marketOverviewIndexParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectConsumerMKOverview',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'segmentEn': 'Skin Care Leave-on',
        'top10Year': utils.defaultYear2,
        'top10CourtnyCode': 'PRC',
        'top5Year': utils.defaultYear2,
        'top5CourtnyCode': 'PRC',
        'countryCode': 'PRC',
        'defYear': utils.defaultYear2

      }
    },
    basfMKSegment: [],
    mapViewBySegmentChangeParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectMapViewBySegmentChange',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'segmentEn': null, // 必须
        'defYear': null // 必须
      }
    },
    mapView: [],

    selectGrowthByCountryChangeParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectSegmentGrowthByCountryChang',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'countryCode': null, // 非必须
        'defYear': null // 非必须
      }
    },
    consumerSegmnts1: [],
    consumerSegmnts2: [],
    consumerSegmnts3: [],

    segmentGrowthBySubSegmentChangeParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectSegmentGrowthBySubSegmentChange',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'countryCode': '', // 非必须
        'segmentEn': '', // 必须
        'defYear': utils.defaultYear2 // 必须
      }
    },
    consumerSubSegmnts1: [],
    consumerSubSegmnts2: [],
    consumerSubSegmnts3: [],
    top10BrandsChangeParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectTop10BrandsChange',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'year': '2018', // 必须
        'countryCode': 'PRC', // 必须
        'segmentEn': null, // 非必须
        'subSegmentEn': null // 非必须
      }
    },
    top10Brands: [],
    top5PerformanceChangeParams: {
      'functionName': 'combiz.service.ConsumerService',
      'methodName': 'selectTop5PerformanceChange',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'year': '2018', // 必须
        'countryCode': 'PRC', // 必须
        'segmentEn': null, // 非必须
        'subSegmentEn': null // 非必须
      }
    },
    top5Performance: [],

    topRankingProductIndexParams: {
      'functionName': 'combiz.service.ConsumerTopRankProductService',
      'methodName': 'selectTopRankingProductIndex',
      'loginId': null,
      'pageNo': 1,
      'pageSize': 10
    },
    bevolGoodsClaims: [],

    selectEsForProductParams: {
      'functionName': 'combiz.service.ConsumerTopRankProductService',
      'methodName': 'selectEsForProduct',
      'loginId': null,
      'pageNo': 1,
      'pageSize': 10,
      'data': {
        'year': null,
        'season': null,
        'claimIds': null,
        'categoryId': null,
        'skinType': null,
        'gender': null,
        'provinceCn': null,
        'ageFrom': null,
        'ageTo': null,
        'priceFrom': null,
        'priceTo': null,
        'searchType': null
      }
    },
    topRankForProducts: null,

    selectTopRankingClaimIndexParams: {
      'functionName': 'combiz.service.ConsumerTopRankClaimService',
      'methodName': 'selectTopRankingClaimIndex',
      'loginId': null,
      'pageNo': 1,
      'pageSize': 10
    },
    sysProvinces: null,

    selectEsForClaimParams: {
      'functionName': 'combiz.service.ConsumerTopRankClaimService',
      'methodName': 'selectEsForClaim',
      'loginId': null,
      'pageNo': 1,
      'pageSize': 10,
      'data': {
        'year': null,
        'season': null,
        'categoryId': null,
        'skinType': null,
        'gender': null,
        'provinceCn': null,
        'ageFrom': null,
        'ageTo': null,
        'priceFrom': null,
        'priceTo': null,
        'searchType': null
      }
    },
    topRankForClaims: null,

    selectEsForClaimPlusParams: {
      'functionName': 'combiz.service.ConsumerTopRankClaimService',
      'methodName': 'selectEsForClaimPlus',
      'loginId': null,
      'pageNo': 1,
      'pageSize': 10,
      'data': {
        'year': null,
        'season': null,
        'categoryId': null,
        'skinType': null,
        'gender': null,
        'provinceCn': null,
        'ageFrom': null,
        'ageTo': null,
        'priceFrom': null,
        'priceTo': null,
        'searchType': null,
        'selectClaimId': null
      }
    },
    topRankForClaims2: null,

    selectFormulationParams: {
      'functionName': 'combiz.service.TopRankingService',
      'methodName': 'selectFormulation',
      'loginId': null,
      'lang': null,
      'data': {
        'category': null
      }
    },
    fomltnTopRankingList: [],

    /**
     * brand ------------------------------------------------------------------------
     */
    brandIndexParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandIndex',
      'loginId': '',
      'lang': null,
      'data': {
        'year': utils.defaultYear,
        'brndClaimIds': null,
        'ctgrId': null,
        'groupId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    sysCountries: [],
    brndGroups: [],
    brndPostnsFirst: [],
    bevolProductCategories: [],
    basfMarketSegment: [],
    pricePostns: [],
    bevolBrndClaims: [],

    brandTop10claims: [],

    brandListParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandList',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'orderBy': null,
        'brndClaimIds': null,
        'ctgrId': null,
        'groupId': null,
        'brndPostnName': null,
        'pricePostnTypename': null,
        'searchName': null
      }
    },
    rptBrndList: [],
    brndSumCount: 0,

    brandDetailParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandDetail',
      'loginId': '',
      'pageNo': 1,
      'pageSize': 10,
      'data': {
        'brndId': '',
        'yearStart': null,
        'yearEnd': null,
        'countryCode': null,
        'segmentEn': null,
        'msSegmentEn': null,
        'msSubSegmentEn': null,
        'msCountryCode': null
      }
    },
    brandDetailDatas: {},

    brandBasicDataParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandBasicData',
      'loginId': '',
      'data': {
        'brndId': null,
        'startDate': null,
        'endDate': null,
        'clickType': 2 // 点击类型：1:年(默认)；2：月；3：周
      }
    },
    brandBasicDataDatas: {},

    brandDshbrdParams: {
      'functionName': 'combiz.service.DashBoardService',
      'methodName': 'selectBrandDshbrd',
      'loginId': '',
      'data': {
        'functionEnDisplay': 'Active', // 成分下拉(查询条件默认Active)
        'year': utils.defaultYear, // 年分(查询条件默认今年)
        'ctgyId': null // 产品分类id(一级分类id)
      }
    },
    brandDshbrdDatas: {}, // data.data

    selectDshbrdIngdntChangeParams: {
      'functionName': 'combiz.service.DashBoardService',
      'methodName': 'selectDshbrdIngdntChange',
      'loginId': '',
      'data': {
        'functionEnDisplay': null // 成分下拉(查询条件默认Active)
      }
    },

    selectDshbrdClaimChangeParams: {
      'functionName': 'combiz.service.DashBoardService',
      'methodName': 'selectDshbrdClaimChange',
      'loginId': '',
      'data': {
        'year': utils.defaultYear // 年分(查询条件默认今年)
      }
    },

    selectDshbrdNewprdctChangeParams: {
      'functionName': 'combiz.service.DashBoardService',
      'methodName': 'selectDshbrdNewprdctChange',
      'loginId': '',
      'data': {
        'ctgyId': null // 产品分类id(一级分类id)
      }
    },

    brandProductParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandProduct',
      'loginId': '',
      'data': {
        'brndId': null, // *
        'year': utils.defaultYear, // *
        'sortBy': null,
        'categoryId': null
      }
    },
    brandProductDatas: {},

    brandCosmrParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandCosmr',
      'loginId': '',
      'data': {
        'brndId': null,
        'functionEnDisplay': null,
        'functionClaimId': null,
        'productCategoryId': null,
        'year': null
      }
    },
    brandCosmrDatas: {},

    brandIndexBrndInfoParams: {
      'functionName': 'combiz.service.BrndInfoService',
      'methodName': 'selectBrandIndexBrndInfo',
      'loginId': '',
      'data': {
        'countryCode': null,
        'segmentName': null,
        'subSegmentName': null,
        'year': null
      }
    },
    brndInfo: [],

    brandIndexBriefCtgyPrdctParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandIndexBriefCtgyPrdct',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'year': null,
        'brndClaimIds': null,
        'ctgrId': null,
        'groupId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    briefCtgyPrdcts: [],
    brandIndexBriefTopPrdctsParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandIndexBriefTopPrdcts',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'year': null,
        'brndClaimIds': null,
        'ctgrId': null,
        'groupId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    briefTopPrdcts: [],
    brandIndexBriefClaimCtgyParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'selectBrandIndexBriefClaimCtgy',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        'year': null,
        'brndClaimIds': null,
        'ctgrId': null,
        'groupId': null,
        'brndPostnName': null,
        'pricePostnTypename': null
      }
    },
    briefClaimCtgies: [],
    category: [],

    brandListExcelDownloadParams: {
      'functionName': 'combiz.service.BrndService',
      'methodName': 'excelDownload',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        brndClaimIds: null,
        ctgrId: null,
        groupId: null,
        brndPostnName: null,
        pricePostnTypename: null,
        orderBy: null,
        searchName: null
      }
    },

    // trend
    trendIndexParams: {
      'functionName': 'combiz.service.TrendService',
      'methodName': 'getSelectDic',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {
        type: 'lifestyle'
      }
    },
    trendIndexDatas: {},
    trendListParams: {
      'functionName': 'combiz.service.TrendService',
      'methodName': 'getDetail',
      'pageNo': 1,
      'pageSize': 10,
      'loginId': '',
      'data': {}
    },
    trendListDatas: {},

    loading: {
      updatePasswordParams: false,
      // boss
      selectBossPopUpParams: false,
      selectProductClaimTop10Params: false,
      selectFormuNewDesignParams: false,
      selectPurchaseParams: false,
      selectLastestFiveProductParams: false,
      selectOrderDetailParams: false,

      loginInterfaceParams: false,

      brandIndexParams: false,
      brandListParams: false,
      brandIndexBrndInfoParams: false,
      brandDshbrdParams: false,
      brandDetailParams: false,
      brandBasicDataParams: false,
      brandProductParams: false,
      brandCosmrParams: false,
      brandIndexBriefCtgyPrdctParams: false,
      brandIndexBriefTopPrdctsParams: false,
      brandIndexBriefClaimCtgyParams: false,

      productIndexParams: false,
      productDetailParams: false,
      prdctDshbrdClmFrmParams: false,
      productListParams: false,
      prdctListSmlrFomltnParams: false,

      selectTop10ClaimAndProductFormParams: false,
      selectTop10ClaimAndSubCategoryParams: false,
      selectTop10PrdDistClaimAndFormParams: false,
      selectTop10PrdDistClaimAndSubCategoryParams: false,
      ingApaProductsTopParams: false,

      formulationIndexParams: false,
      formulationListParams: false,
      formulationDetailParams: false,
      fomltnSimilarParams: false,
      fomltnBenchmarkParams: false,

      ingredientIndexParams: false,
      ingrdntTrdIndexParams: false,
      ingredientDetailParams: false,
      ingrdntTrdDetailParams: false,
      ingApaByCategoryParams: false,
      ingrdntCombinateSelectParams: false,

      // compare
      selectBrandComparisonParams: false,
      productComparisonParams: false,
      changeIngrdntsParams: false,
      selectFomltnComparisonParams: false,
      selectIngrdntComparisonParams: false,

      // consumer insights
      marketOverviewIndexParams: false,
      mapViewBySegmentChangeParams: false,
      segmentGrowthBySubSegmentChangeParams: false,
      selectGrowthByCountryChangeParams: false,
      top10BrandsChangeParams: false,
      top5PerformanceChangeParams: false,
      topRankingProductIndexParams: false,
      selectEsForProductParams: false,
      selectTopRankingClaimIndexParams: false,
      selectEsForClaimParams: false,
      selectEsForClaimPlusParams: false,
      selectFormulationParams: false,

      // concepts collection
      conceptIndexParams: false,
      searchAllParams: false,
      newConceptListParams: false,

      advanceSearch: false,

      // dashboard
      selectDshbrdIngdntChangeParams: false,
      selectDshbrdClaimChangeParams: false,
      selectDshbrdNewprdctChangeParams: false,

      // trend
      trendIndexParams: false,
      trendListParams: false
    },

    ecoHelp: [
      {
        title: 'BASF Natural',
        icon: require('../assets/images/trade/4-BASF Naturals.png'),
        text: 'From 100% natural, renewable feedstocks; Physically purified by water/achohol or energy.'
      },
      {
        title: 'BASF Natural modified',
        icon: require('../assets/images/trade/3-BASF Natural modified.png'),
        text: 'From 100% natural, renewable feedstocks; Chemically processed, catalyst or reaction aids used.'
      },
      {
        title: 'BASF Ecohybrids',
        icon: require('../assets/images/trade/2-BASF Natural modified.png'),
        text: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms > 70%.'
      },
      {
        title: 'BASF Hybrids',
        icon: require('../assets/images/trade/1-BASF Hybrids.png'),
        text: 'From 100% natural, renewable & synthetic feedstocks; Renewable & synthetic building blocks are combined in a chemical process. Share nature C-atoms < 70%.'
      },
      {
        title: 'BASF Synthetics',
        icon: require('../assets/images/trade/0-BASF Synthetics.png'),
        text: 'From synthetic feedstocks; Chemically processed.'
      },
      {
        title: 'BASF Inorganics',
        icon: require('../assets/images/trade/0-BASF Inorganics.png'),
        text: 'From inorganic feedstocks'
      },
      {
        title: 'BASF Animals',
        icon: require('../assets/images/trade/0-BASF Animals.png'),
        text: 'From animal feedstocks'
      }
    ]
  },
  // 获取属性的状态
  getters,
  // 改变属性的状态
  mutations,
  // 应用mutations
  actions,
  // 模块
  modules
})



// WEBPACK FOOTER //
// ./src/store/store.js